module.exports = __webpack_public_path__ + "img/event_bonne_annee_2023.86d46e08.jpg";